<template>
  <div style="height: 100%" :key="selectedProject">
    <v-card
      class="d-flex flex-column"
      min-height="100%"
    >
      <v-card-title>
        Employees on project
        <v-spacer></v-spacer>
        <v-text-field
          dense
          hide-details
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-4">
        <v-data-table
          :key="updateTable"
          dense
          mobile-breakpoint="0"
          :items="rangeList"
          :headers="headers"
          :item-class="itemRowBackground"
          :items-per-page="10"
          :search="search"
          :loading="isLoading"
        >
        </v-data-table>
      </v-card-text>
      <v-divider class="mt-auto"></v-divider>
      <v-card-actions>
        <h5>
          <span style="color: rgba(175, 175, 169, 0.699)">Grey</span> color represents employees, which haven't reported to chosen project during last month.
          <br />
          <span style="color: rgb(230, 145, 130)">Red</span> color represents employees, which aren't working in our company for now.
        </h5>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'NewComponent',
  data () {
    return {
      rangeList: [],
      isLoading: false,
      search: '',
      updateTable: 0,
      headers: [
        {
          text: 'Employee\'s Full Name',
          value: 'Full_Name',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: 'auto'
        },
        {
          text: 'First Report\'s Date',
          value: 'First_Reports_Date',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: 'auto'
        },
        {
          text: 'Last Report\'s Date',
          value: 'Last_Reports_Date',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: 'auto'
        },
        {
          text: 'Months Of Working On Project',
          value: 'Month_Of_Work',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: '5%'
        },
        {
          text: 'Years Of Working On Project',
          value: 'Years_Of_Work',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: '5%'
        }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    selectedProject () {
      const projectID = this.$store.getters.getSelectedProject
      this.getEmployeesReportingRangeOnProject(projectID)
      return typeof projectID === 'object' ? projectID?.id || '' : projectID
    }
  },
  methods: {
    async getEmployeesReportingRangeOnProject (projectID) {
      this.rangeList = []
      this.isLoading = true
      await this.axios.get(`/api/metrics/get_employees_reporting_range_on_project_ID/${projectID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].First_Reports_Date = new Date(res.data[i].First_Reports_Date).toISOString().substring(0, 10)
          res.data[i].Last_Reports_Date = new Date(res.data[i].Last_Reports_Date).toISOString().substring(0, 10)
          this.rangeList.push(res.data[i])
        }
        this.updateTable++
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
      this.isLoading = false
    },
    itemRowBackground (item) {
      if (item.Employee_Left_Date || item.Is_Employee_Deleted) {
        return 'style-employee-left'
      }
      if (!item.Is_Active) {
        return 'style-not-active-employee'
      }
      return ''
    }
  }
}
</script>

<style>
.style-employee-left {
  background-color: rgb(230, 145, 130)
}
.style-not-active-employee {
  background-color: rgba(175, 175, 169, 0.699)
}
</style>
